import forEach from 'lodash/forEach';

function validatePulseStrengthChecks(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];
  nodeInfo.checkNodes.forEach((checkNode) => {
    forEach(checkNode.data, (check, checkKey) => {
      if (check.type !== 'PULSE_STRENGTH') return;

      if (!check.ids || !check.ids.length) {
        errors.push({
          message: 'You need to select a location to check pulse strength for',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: checkNode.id,
          metadata: {
            nodeId: checkNode.id,
            checkKey,
            scope: 'control',
          },
        });
      }
    });
  });
  return {
    errors,
    warnings,
  };
}

export default validatePulseStrengthChecks;
